// Soft pastel palette used to color a saved ritual's dots on the calendar.
// Deterministic pick based on recipe id so the color stays stable.
const PALETTE = [
  { name: 'sage', bg: '#a7c4a0', ring: '#7a8b6b' },
  { name: 'terracotta', bg: '#d4a89b', ring: '#7a3b2e' },
  { name: 'honey', bg: '#e6ccb2', ring: '#a67c52' },
  { name: 'powder', bg: '#b8c5d6', ring: '#5c7898' },
  { name: 'lilac', bg: '#c9b8d6', ring: '#7d6a9b' },
  { name: 'rose', bg: '#e0b4b4', ring: '#a26d6d' },
  { name: 'cream', bg: '#e9d8c4', ring: '#a68b6b' },
  { name: 'moss', bg: '#c2ceac', ring: '#6b7d4e' },
];

export function colorForRitual(recipeId) {
  if (!recipeId) return PALETTE[0];
  let hash = 0;
  for (let i = 0; i < recipeId.length; i++) {
    hash = (hash * 31 + recipeId.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
}

export { PALETTE };
